export default "/assets/577212f0f1f76dba.svg"